import { Directive, HostListener } from '@angular/core';

// Enlève le focus immédiatement si le focus vient d'un clic de souris
// Permet d'éviter de voir le style du focus quand on clique sur un bouton
@Directive({
  selector: '[appBlurOnMouseClick]',
  standalone: false
})
export class BlurOnMouseClickDirective {
  isMouseDown = false;

  @HostListener('mousedown')
  mouseDown() {
    this.isMouseDown = true;
  }

  @HostListener('mouseup')
  mouseUp() {
    this.isMouseDown = false;
  }

  @HostListener('focus', ['$event'])
  blurMouseClick(event) {
    if (this.isMouseDown) {
      (event.target as HTMLElement).blur();
    }
  }
}
